import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./components/Login";
import "./style/app.css";
import { useEffect, useContext } from "react";
import "./style/adminhome.css";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { useCallback } from "react";
import Main from "./components/Main";

function App() {
  const [userContext, setUserContext] = useContext(AuthContext);

  const syncLogout = useCallback((event) => {
    if (event.key === "managerLogout") {
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("storage", syncLogout);
    return () => {
      window.removeEventListener("storage", syncLogout);
    };
  }, [syncLogout]);

  return (
    <div className="app">
      {userContext.token ? (
        <Main userContext={userContext} setUserContext={setUserContext} />
      ) : (
        <div>
          <header></header>
          <div className="content">
            <Routes>
              <Route exact path="/" index element={<Login />} />
            </Routes>
          </div>
        </div>
      )}
    </div>
  );
}

const AppWrapper = () => (
  <AuthProvider>
    <Router>
      <App />
    </Router>
  </AuthProvider>
);
export default AppWrapper;
